module.exports = __webpack_public_path__ + "img/33ea057.svg";